module.exports = __webpack_public_path__ + "img/modulo_Parrafo.fd9bf16.svg";